import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { ContactSection } from "@/components/site/ContactSection";
import { EnquiryForm } from "@/components/site/EnquiryForm";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Contact() {
  usePageMeta("Contact Us", "Contact Suvirika Retail Pvt Ltd for business enquiries, partnerships and corporate information.");
  return (
    <>
      <PageHero
        eyebrow="Contact Us"
        lines={["Let's start", <em key="i" className="italic font-light text-sky-ink">a conversation.</em>]}
        intro="For partnerships, brand enquiries or general questions, use the form below. Our team will respond to the email you provide."
        testId="contact-hero"
      />
      <section className="pb-16">
        <div className="container-x"><ContactSection /></div>
      </section>
      <section className="py-16 md:py-24">
        <div className="container-x">
          <Reveal className="border hairline bg-white p-6 md:p-12">
            <h2 className="font-display text-3xl">Send an enquiry</h2>
            <p className="mt-2 mb-10 text-[var(--ink-2)]">Fields marked * are required.</p>
            <EnquiryForm testId="contact-form" />
          </Reveal>
        </div>
      </section>
    </>
  );
}
